export enum ShortCut {
  'TODAY' = 'TODAY',
  'YESTERDAY' = 'YESTERDAY',
  'THIS_WEEK' = 'THIS_WEEK',
  'THIS_MONTH' = 'THIS_MONTH',
  'THIS_YEAR' = 'THIS_YEAR',
}
